export default {
	menu: {
		menu:{
			button:[]
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/menu/state.js